import { render, staticRenderFns } from "./APITable.vue?vue&type=template&id=2d7b20a0&"
import script from "./APITable.vue?vue&type=script&lang=js&"
export * from "./APITable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports